import React, { useState } from 'react';
import { IconButton, makeStyles, colors } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

import MainAdornment from 'components/textfield/MainAdornment';
import MainTextfield from 'components/textfield/MainTextfield';

const useStyles = makeStyles({
  button: {
    color: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
      color: colors.red[200],
    },
  },
});

const PasswordTextfield = ({
  value,
  onChange,
  errorMessage,
  label = 'Password',
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const classes = useStyles();

  const _onClick = () => setShowPassword(!showPassword);

  return (
    <MainTextfield
      label={label}
      fullWidth
      onChange={(e) => onChange(e.target.value)}
      value={value}
      error={!!errorMessage}
      helperText={errorMessage}
      type={showPassword ? 'text' : 'password'}
      endAdornment={
        <MainAdornment>
          <IconButton onClick={_onClick} className={classes.button}>
            {showPassword ? (
              <Visibility></Visibility>
            ) : (
              <VisibilityOff></VisibilityOff>
            )}
          </IconButton>
        </MainAdornment>
      }
    ></MainTextfield>
  );
};

export default PasswordTextfield;
